import React from 'react';
import Row from '../Symbols/Row';
import Button from '../Symbols/Button';
import Result from './Result';
import Form from '../Symbols/Form';
import Input from '../Symbols/Input';
import InputCurrency from '../Symbols/InputCurrency';
import Wrapper from '../Symbols/Wrapper';

const emptyFunc = () => {};

export default props => {
	const {
		validateHandler = emptyFunc,
		changeHandler = emptyFunc,
		errors = {},
		state: { credit, payment, number, tax, monthlyFees },
		result = null,
		onSubmit,
		reset,
	} = props;

	return (
		<Wrapper>
			<Form onSubmit={onSubmit} title="Kalkulačka – RPSN">
				<InputCurrency
					label="Výše úvěru"
					name="credit"
					value={credit}
					onChange={changeHandler('credit')}
					onBlur={validateHandler('credit')}
					passedProps={{ min: 1, step: 1, 'data-cy': 'credit' }}
					error={errors.credit}
				/>

				<InputCurrency
					label="Kolik je pravidelná měsíční splátka"
					name="payment"
					value={payment}
					onChange={changeHandler('payment')}
					onBlur={validateHandler('payment')}
					passedProps={{ min: 1, step: 1, 'data-cy': 'payment' }}
					error={errors.payment}
				/>

				<Input
					label="Jak dlouho budete splácet (kolik měsíců)"
					name="number"
					value={number}
					type="number"
					onChange={changeHandler('number')}
					onBlur={validateHandler('number')}
					passedProps={{ min: 1, max: 999, step: 1, 'data-cy': 'number' }}
					error={errors.number}
				/>

				<InputCurrency
					label="Poplatek za uzavření"
					name="tax"
					value={tax}
					onChange={changeHandler('tax')}
					onBlur={validateHandler('tax')}
					passedProps={{ min: 0, step: 1, 'data-cy': 'tax' }}
					error={errors.tax}
				/>

				<InputCurrency
					label="Jiné pravidelné měsíční poplatky"
					name="monthlyFees"
					value={monthlyFees}
					onChange={changeHandler('monthlyFees')}
					onBlur={validateHandler('monthlyFees')}
					passedProps={{ min: 0, step: 1, 'data-cy': 'monthlyFees' }}
					error={errors.monthlyFees}
				/>

				<div css={Row}>
					<Button data-cy="submit">Výpočet</Button>
				</div>

				{result && <Result rpsn={result} />}
				{result && (
					<div css={Row}>
						<Button onClick={reset} data-cy="reset">
							Nový výpočet
						</Button>
					</div>
				)}
			</Form>
		</Wrapper>
	);
};
